'use client'

import Logo from '$/public/logo/logo.svg'
import { animTransFadeOut, animTransSlideOut } from '@/animations/transitions'
import { useGSAPMedia } from '@/hooks'
import { useStoreTransition } from '@/store'
import { MEDIA } from '@config'
import { useRef } from 'react'

const TransitionOut = () => {
  const comp = useRef<any>(null)
  const tl = useRef<GSAPTimeline | null>(null)

  const { isTransitionOut, transitionType, setIsTransitioning } =
    useStoreTransition()

  useGSAPMedia({
    media: MEDIA,
    scope: comp,
    type: 'effect',
    deps: [transitionType, isTransitionOut],
    callback: (_c) => {
      if (!transitionType || !isTransitionOut) return
      setIsTransitioning(true)
      switch (transitionType) {
        case 'slide':
          animTransSlideOut({
            tl: tl.current,
            comp: comp,
            name: 'slide-out'
          })
          break
        case 'fade':
          animTransFadeOut({
            tl: tl.current,
            comp: comp,
            name: 'fade-out'
          })
          break
      }
    }
  })

  //if (!isTransitionOut) return null
  return (
    <div ref={comp}>
      {transitionType === 'slide' && (
        <div
          className={
            'bg-primary-200 fixed bottom-0 left-0 z-2000 flex h-0 w-full items-center justify-center overflow-hidden'
          }
          data-transition="slide-out"
        >
          <div className="p-x-md absolute inset-0 flex items-center justify-center text-white">
            <Logo className="h-20 w-40" />
          </div>
        </div>
      )}
      {transitionType === 'fade' && (
        <div
          className={
            'fixed top-0 left-0 z-[450] h-full w-full bg-neutral-200 opacity-0'
          }
          data-transition="fade-out"
        />
      )}
    </div>
  )
}

export default TransitionOut
